import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import RoleService from "../Services/RoleService/RoleService";

export const get = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return RoleService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      if (data.length > 0) {
        store.state.data = data;
      } else {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getModulelist = (store) => {
  RoleService.getModule()
    .then((response) => {
      let data = response.data;
      store.setState({
        module: data,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, query) => {
  RoleService.getData(query)
    .then((response) => {
      const data = response.data;
      let result = data.result;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      if (data.result.length > 0) {
        store.state.data = store.state.data.concat(result);
      } else {
        store.state.lastPage = true;
      }
      store.state.header = response.headers;
      store.setState({
        isLoading,
        data: store.state.data,
        header: store.state.header,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getSingle = async (store, query) => {
  RoleService.getDataRole(query)
    .then((response) => {
      let data = response.data;
      store.setState({
        dataRole: data,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await RoleService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Role", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const put = async (store, value, index) => {
  try {
    const response = await RoleService.putData(value);
    const data = response.data;
    notifUtils("Successfully Updated Role", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
export const deleted = async (store, query) => {
  try {
    const response = await RoleService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Remove Role", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
